export const GET_MY_COMPANY_REQUEST = "GET_MY_COMPANY_REQUEST";
export const GET_MY_COMPANY_SUCCESS = "GET_MY_COMPANY_SUCCESS";
export const GET_MY_COMPANY_FAILURE = "GET_MY_COMPANY_FAILURE";

export const CLEAR_MY_COMPANY = "CLEAR_MY_COMPANY";

/** After DELETE company_edit_request succeeds, drop nested request before GET /my_company finishes (avoids a stray GET /company_edit_requests/:id → 404). */
export const CLEAR_MY_COMPANY_ACTIVE_EDIT_REQUEST =
  "CLEAR_MY_COMPANY_ACTIVE_EDIT_REQUEST";
